// map extracted fields to data view based on context type
import {
  IAutoInsuranceExtractionResponse,
  IBusinessCardExtractionResponse,
  IDriversLicenseExtractionResponse,
  IResumeExtractionResponse
} from "@wingspanhq/shared-files/dist/lib/constants/extractions";
import { SharedFileRequestContextType } from "@wingspanhq/wingspan-api-sdk";

import { DataItemProps } from "../../../../../../shared/components/DataView";

import { mapBusinessCardExtractedFieldsToDataView } from "./mapBusinessCardExtractedFieldsToDataView";
import { mapDriversLicenseExtractedFieldsToDataView } from "./mapDriversLicenseExtractedFieldsToDataView";
import { mapResumeExtractedFieldsToDataView } from "./mapResumeExtractedFieldsToDataView";

// The extraction payload interfaces keep typing the untyped
// `SharedFileRequestJob.extractedFields` bag — v3 has no per-context shape.
export const mapContextTypeExtractedFieldsToDataView = (
  extractedFields:
    | IDriversLicenseExtractionResponse
    | IBusinessCardExtractionResponse
    | IResumeExtractionResponse
    | IAutoInsuranceExtractionResponse
    | undefined,
  contextType: SharedFileRequestContextType | string | undefined
): DataItemProps[] => {
  switch (contextType) {
    case SharedFileRequestContextType.BUSINESS_CARD:
      return mapBusinessCardExtractedFieldsToDataView(
        extractedFields as IBusinessCardExtractionResponse
      );
    case SharedFileRequestContextType.DRIVERS_LICENSE:
      return mapDriversLicenseExtractedFieldsToDataView(
        extractedFields as IDriversLicenseExtractionResponse
      );
    case SharedFileRequestContextType.RESUME:
      return mapResumeExtractedFieldsToDataView(
        extractedFields as IResumeExtractionResponse
      );
    default:
      return [];
  }
};
